export const COOKIE_CONSENT_KEY = "socrattica.cookie-consent.v1";
export const COOKIE_CONSENT_EVENT = "socrattica:cookie-consent";
export const OPEN_COOKIE_PREFERENCES_EVENT = "socrattica:open-cookie-preferences";

export interface CookieConsent {
  version: 1;
  necessary: true;
  analytics: boolean;
  updatedAt: string;
}

export function readCookieConsent(): CookieConsent | null {
  if (typeof window === "undefined") return null;

  try {
    const parsed = JSON.parse(
      window.localStorage.getItem(COOKIE_CONSENT_KEY) ?? "null",
    ) as Partial<CookieConsent> | null;

    if (
      parsed?.version !== 1 ||
      parsed.necessary !== true ||
      typeof parsed.analytics !== "boolean"
    ) {
      return null;
    }

    return {
      version: 1,
      necessary: true,
      analytics: parsed.analytics,
      updatedAt: typeof parsed.updatedAt === "string" ? parsed.updatedAt : "",
    };
  } catch {
    return null;
  }
}

export function hasAnalyticsConsent() {
  return readCookieConsent()?.analytics === true;
}

export function saveCookieConsent(analytics: boolean): CookieConsent {
  const consent: CookieConsent = {
    version: 1,
    necessary: true,
    analytics,
    updatedAt: new Date().toISOString(),
  };

  try {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consent));
  } catch {
    // La preferencia se mantiene durante esta vista mediante el evento.
  }

  window.dispatchEvent(new CustomEvent<CookieConsent>(COOKIE_CONSENT_EVENT, { detail: consent }));
  return consent;
}

export function openCookiePreferences() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(OPEN_COOKIE_PREFERENCES_EVENT));
}

export function clearGoogleAnalyticsCookies() {
  if (typeof document === "undefined") return;

  const names = document.cookie
    .split(";")
    .map((cookie) => cookie.split("=")[0]?.trim())
    .filter((name): name is string => Boolean(name && (name === "_ga" || name.startsWith("_ga_"))));

  for (const name of names) {
    document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
    document.cookie = `${name}=; Max-Age=0; path=/; domain=${window.location.hostname}; SameSite=Lax`;
    const parentDomain = window.location.hostname.split(".").slice(-2).join(".");
    if (parentDomain.includes(".")) {
      document.cookie = `${name}=; Max-Age=0; path=/; domain=.${parentDomain}; SameSite=Lax`;
    }
  }
}
